import Vue from 'vue';
import Vuex from 'vuex';

import cmsText from './modules/cmsText';
import siteSettings from './modules/siteSettings';
import forms from './modules/forms';
import products from './modules/products';
import customerData from './modules/customerData';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export const state = {
  hasShippingData: false,
};

export const mutations = {
  /* eslint-disable no-param-reassign */
  setHasShippingData(storeState, payload) {
    storeState.hasShippingData = payload.hasShippingData;
  },
  /* eslint-enable no-param-reassign */
};

export default new Vuex.Store({
  modules: {
    siteSettings,
    cmsText,
    forms,
    products,
    customerData,
  },
  state: { ...state },
  mutations,
  strict: debug,
});
